import { erpAxios } from '.';

const deleteIbsPustanjaKreditaAnalitika = async (id) => {
  const res = await erpAxios.delete(`/ibsPustanjaKreditaAnalitika/${id}`);
  return res;
};

export default deleteIbsPustanjaKreditaAnalitika;
